'use client';

import { InfoCircle } from 'icons/ButtonIcons/InfoCircle';
import { useState } from 'react';
import { tooltip as Tooltip } from '@/app/_components/Base/Tooltip';
import { Link } from '@/app_components/common/Link';

interface PaidContentProps {
  ctaUrl: string;
}

export const PaidContent = ({ ctaUrl }: PaidContentProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <div className='relative'>
      <button
        aria-label='Advertiser Disclosure Information'
        className='bg-accent-inverse text-accent font-graphik-compact text-sm font-medium flex items-center gap-2 px-2 py-1 transition-colors hover:underline'
        onMouseEnter={() => setIsTooltipOpen(true)}
        type='button'
      >
        Paid Content
        <InfoCircle
          className='w-4 h-4'
          fill='fill-blue-500'
        />
      </button>
      <Tooltip
        className='left-0'
        content={
          <p>
            Paid content by{' '}
            <Link
              className='underline'
              href={`${ctaUrl}&utm_content=disclaimer_link`}
              target='_blank'
              data-cy='ez-newswire-disclaimer-link'
            >
              EZ Newswire
            </Link>
            . The Fortune staff was not involved in producing this content.
          </p>
        }
        isOpen={isTooltipOpen}
        onClose={() => setIsTooltipOpen(false)}
        title='Paid Content'
      />
    </div>
  );
};
